<template>
  <v-data-table
    :headers="headers"
    :items="remesasPersonal"
    class="transparent"
    hide-default-footer
    disable-pagination
    calculate-widths
  >
    <template v-slot:[`item.fk_idRemesa`]="{ item }">
      {{ item.fk_idRemesa }}
    </template>
    <template v-slot:[`item.fecha`]="{ item }">
      {{ humanizeDate(item.fecha) }}
    </template>
    <template v-slot:[`item.numOficio`]="{ item }">
      {{ getNumOficio(item.fk_idRemesa) }}
    </template>
  </v-data-table>
</template>

<script>
import DateAdapter from '@src/utils/DateAdapter'

export default {
  props: {
    remesasPersonal: {
      type: Array,
      required: true,
      default: () => [],
    },
    remesas: {
      type: Array,
      required: true,
      default: () => [],
    },
  },

  data() {
    return {
      headers: [
        { text: 'ID Remesa', value: 'fk_idRemesa', align: 'right' },
        { text: 'Fecha de asignación', value: 'fecha' },
        { text: 'No. de oficio', value: 'numOficio' },
      ],
    }
  },

  methods: {
    humanizeDate(date) {
      if (date) {
        return new DateAdapter(date, 'YYYY-MM-DDTHH:mm:ss').toHumanReadable()
      }

      return '-'
    },

    getNumOficio(idRemesa) {
      const remesa = this.remesas.find((r) => r.idRemesa === idRemesa)
      return remesa?.numOficio || '-'
    },
  },
}
</script>
